export default {
  "preview.header": "",
  "preview.link.ja": "",
  "preview.link.en": "",
  "preview.link.bbt": "",
} as const;
